<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M14,3C14,2.45,13.55,2,13,2C12.72,2,12.47,2.11,12.29,2.29C12.29,2.29,4,10.59,4,10.59C4,10.59,4,6,4,6C4,5.45,3.55,5,3,5C2.45,5,2,5.45,2,6C2,6,2,13,2,13C2,13.55,2.45,14,3,14C3,14,10,14,10,14C10.55,14,11,13.55,11,13C11,12.45,10.55,12,10,12C10,12,5.41,12,5.41,12C5.41,12,13.7,3.71,13.7,3.71C13.89,3.5300000000000002,14,3.2800000000000002,14,3C14,3,14,3,14,3Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'ArrowBottomLeft',
} as DefineComponent
</script>
